import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeService } from 'src/app/_Core/_Services/employee.service';

@Component({
  standalone: false,
  selector: 'app-security-password-resend',
  templateUrl: './security-password-resend.component.html',
  styleUrls: ['./security-password-resend.component.scss'],
})
export class SecurityPasswordResendComponent implements OnInit {
  @Input() tenantSecurityId: string;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private employeeService: EmployeeService,
  ) {
  }

  ngOnInit(): void { }

  sendNewPassword() {
    this.employeeService.regenerateCompanySecuritPassword(this.tenantSecurityId).subscribe({
      next: (res) => {
        console.log(res);
        if (res.isValid) {
          // location.reload();
        }
      },
      error: (err) => {
        console.error('Error regenerating password:', err);
        // Handle error response
      }
    });
    this.modal.dismiss();
  }
}
